import { useContext, useEffect } from "react";
import stateContext from "../Context/StateContext";

const TopMessage = () => {
    const globalState = useContext(stateContext);

    useEffect(() => {
        if (globalState.message) {
            const timer = setTimeout(() => {
                globalState.setMessage(null); // assuming setMessage exists in your context
            }, 2000);

            return () => clearTimeout(timer);
        }
    }, [globalState.message]);

    if (!globalState.message) return null;

    return (
        <div
            style={{
                position: "absolute",
                top: "20%",
                left: "50%",
                transform: "translateX(-50%) translateY(-50%)",
                zIndex: 9999,
                background: "transparent",
                backgroundColor: "#ffffffff",
                color: "#020000ff",
                padding: "10px 20px",
                border: "px solid #000000ff",
                borderRadius: "8px",
                textAlign: "center",
                fontWeight: "bold",
                boxShadow: "2px 2px 8px rgba(0,0,0,0.5)",
                maxWidth: "80%",
            }}
        >
            {globalState.message}
        </div>
    );
};

export default TopMessage;
